<template>
  <div style="padding-top: 40px">
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;">
      <tr>
        <td bgcolor="#ffffff">
          <div align="center">
            <table border="0" cellpadding="0" cellspacing="0" width="550" class="wrapper" style="border-left: 1px solid #f2f2f2; border-top: 1px solid #f2f2f2;
    border-right: 1px solid #f2f2f2">
              <tr>
                <td style="padding: 20px 15px 0;" class="logo">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                      <td bgcolor="#ffffff" width="100" align="left">
                        <a href="#" target="_blank">
                          <img width="120" alt="Logo" src="/assets/img/ang-logo.png" style="display: block; font-family: Helvetica, Arial, sans-serif;
                               color: #666666; font-size: 16px;" border="0"/>
                        </a>
                      </td>
                      <td bgcolor="#ffffff" width="400" align="right" class="mobile-hide">
                        <table border="0" cellpadding="0" cellspacing="0">
                          <tr>
                            <td align="right"
                                style="font-size: 14px; font-family: Arial, sans-serif; color: #666666; text-decoration: none;">
                              <img width="120" alt="Decoration" src="/assets/img/deco.png" style="display: block; font-family: Helvetica, Arial, sans-serif;
                               color: #666666; font-size: 16px;" border="0"/>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;">
      <tr>
        <td bgcolor="#ffffff" align="center" class="section-padding">
          <table border="0" cellpadding="0" cellspacing="0" width="550" class="responsive-table"
                 style="border-left: 1px solid #f2f2f2; border-right: 1px solid #f2f2f2;">
            <tr>
              <td>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tr>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0">
                        <tr>
                          <td align="center" style="font-size: 25px; font-family: Helvetica, Arial, sans-serif; color: #333333; padding-bottom: 20px;"
                              class="padding-copy">Zależy nam na Twojej opinii!
                          </td>
                        </tr>
                        <tr>
                          <td align="left"
                              style="padding: 20px 15px 0; font-size: 16px; line-height: 25px; font-family: Helvetica, Arial, sans-serif; color: #666666;"
                              class="padding-copy">Szanowna Pani, Szanowny Panie,
                          </td>
                        </tr>
                        <tr>
                          <td align="left"
                              style="padding: 20px 15px 0; font-size: 16px; line-height: 25px; font-family: Helvetica, Arial, sans-serif; color: #666666;"
                              class="padding-copy">cieszymy się, że nasz Ekspert mógł pomóc Pani/Panu w uzyskaniu kredytu bankowego. Ponieważ zależy nam na
                            jakości świadczonych usług, jesteśmy bardzo ciekawi Pani/Pana opinii na temat współpracy z Ekspertem ANG.
                            Uprzejmie prosimy o uzupełnienie bardzo krótkiej ankiety. Jej wyniki pomogą nam w lepszej realizacji naszej misji, którą jest
                            dostarczanie Państwu usług finansowych potrzebnych, zrozumiałych, na które Państwa stać i za godziwą cenę.
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="mobile-button-container">
                        <tr>
                          <td align="center" style="padding: 25px 0;" class="padding-copy">
                            <table border="0" cellspacing="0" cellpadding="0" class="responsive-table">
                              <tr>
                                <td align="center"><a href="#" target="_blank"
                                                      style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: normal; color: #ffffff;
                                                       text-decoration: none; background-color: #4E143B; border-top: 15px solid #4E143B; border-bottom: 15px solid #4E143B; border-left: 25px solid #4E143B; border-right: 25px solid #4E143B; border-radius: 3px; -webkit-border-radius: 3px; -moz-border-radius: 3px; display: inline-block;"
                                                      class="mobile-button">Wypełnij ankietę &rarr;</a></td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" class="padding-copy" style="padding: 0 15px;">
                            <table border="0" cellspacing="0" cellpadding="0" class="responsive-table">
                              <tr>
                                <td align="left">
                                  <img width="120" alt="Decoration" src="/assets/img/deco-2.png" style="padding: 10px 0; display: block; font-family: Helvetica, Arial, sans-serif;
                               color: #666666; font-size: 16px;" border="0"/>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                      <table border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;">
                        <tr>
                          <td bgcolor="#ffffff" align="center">
                            <table border="0" cellpadding="0" cellspacing="0" width="550" class="responsive-table">
                              <tr>
                                <td>
                                  <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                    <tr>
                                      <td align="right"
                                          style="padding: 0 15px; font-size: 16px; line-height: 25px; font-family: Helvetica, Arial, sans-serif; color: #666666;"
                                          class="padding-right">Dziękujemy,
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="right"
                                          style="padding: 0 15px; font-size: 16px; line-height: 25px; font-family: Helvetica, Arial, sans-serif; color: #666666;"
                                          class="padding-right">Katarzyna Dmowska, Artur Nowak-Gocławski, Michał Kwasek
                                      </td>
                                    </tr>
                                    <tr>
                                      <td align="right"
                                          style="padding: 0 15px; font-size: 16px; line-height: 25px; font-family: Helvetica, Arial, sans-serif; color: #666666;"
                                          class="padding-right"><strong>Zarząd ANG Spółdzielni</strong>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <!-- FOOTER -->
    <table border="0" cellpadding="0" cellspacing="0" width="100%"
           style="table-layout: fixed;">
      <tr>
        <td bgcolor="#ffffff" align="center">
          <table width="100%" border="0" cellspacing="0" cellpadding="0" align="center">
            <tr>
              <td style="padding-bottom: 20px;">
                <!-- UNSUBSCRIBE COPY -->
                <table width="550" border="0" cellspacing="0" cellpadding="0" align="center" class="responsive-table"
                       style="border-left: 1px solid #f2f2f2; border-right: 1px solid #f2f2f2; border-bottom: 1px solid #f2f2f2;">
                  <tr>
                    <td align="center" valign="middle"
                        style="padding: 30px 0 15px; font-size: 12px; line-height: 18px; font-family: Helvetica, Arial, sans-serif; color:#666666;">
                      <span class="appleFooter" style="color:#666666;">2020-09-09 10:05:54</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  name: 'CustomerResearchMail.vue',
  components: {}
}
</script>
